interface Props {
  asLink: boolean;
  articleThumbnailSrc: string;
  asFullWidth?: boolean;
  articleLink?: string;
  articleTitle?: string;
}

export const Thumbnail = ({ asLink, articleLink, articleThumbnailSrc, articleTitle, asFullWidth = false }: Props) => {
  const imageClassName = asFullWidth ? 'w-full h-auto object-cover' : 'w-full h-auto object-cover';

  return asLink ? (
    <a href={articleLink} target="_blank" rel="noreferrer" data-skip-tracking="true" className="block w-full">
      <img src={articleThumbnailSrc} alt={articleTitle} className={imageClassName} />
    </a>
  ) : (
    <img src={articleThumbnailSrc} alt={articleTitle} className={imageClassName} />
  );
};
